import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50413a6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  class: "w-4 h-4 fill-current"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["value"]

import InputField from './InputField.vue';
import { useVModels } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: null,
  },
  hint: {
    type: String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: String,
    default: null,
  },
  placeholder: {
    type: String,
    default: null,
  },
  status: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props





const { modelValue: value } = useVModels(props, emit);

return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createBlock(InputField, {
    title: __props.title,
    "validation-error": __props.validationError,
    hint: __props.hint
  }, {
    "title-badge": _withCtx(() => [
      (_ctx.$slots['title-badge'])
        ? _renderSlot(_ctx.$slots, "title-badge", { key: 0 })
        : _createCommentVNode("", true)
    ]),
    status: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.status), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_date_picker, {
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        mode: "dateTime",
        disabled: __props.disabled,
        class: _normalizeClass([
        'border-b w-full my-2 py-1',
        {
          'border-red-500 text-red-500': __props.validationError,
          'border-input-decoration': !__props.validationError,
        },
      ])
      }, {
        default: _withCtx(({ inputValue, togglePopover }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "p-2 text-primary hover:text-primary-dark",
              onClick: ($event: any) => (togglePopover())
            }, _hoisted_4, 8, _hoisted_2),
            _createElementVNode("input", {
              value: inputValue,
              class: "w-full px-2 py-1.5",
              readonly: ""
            }, null, 8, _hoisted_5)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "class"])
    ]),
    _: 3
  }, 8, ["title", "validation-error", "hint"]))
}
}

})